module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch7"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch7.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With your eye on the candle in the window, you start screaming wildly. You fling your arms in the air and flap your hands. You bob your head up and down like a dashboard doll with a loose spring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Grab the kid!” the worker shouts at the Strangler.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Liz can’t believe her eyes. You’ve never gone totally berserk before. You wink at her, and then she gets the idea. Now she shrieks wildly, too!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the attention turns to Liz, you reach for the candle in the window. You wave the flickering flame in the face of the Strangler. Back and forth, closer and closer to his waxy cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!” the man in overalls screams when he sees what you’re up to. “Not fire! He’ll melt! Take it away!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s too late for the Strangler. From beneath the wide-brimmed hat, flesh-colored wax drips down in a puddle. The museum worker pushes you aside and tries to glob the hot wax back into place. He looks up at you and snarls, “You’ll pay for this. I promise you that!”")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Get out of there while you still can. Run to "), _c('span', {
    attrs: {
      "href": "#/e9780545841733_ch109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAGE 109")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e00dc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841733_ch007.vue
// module id = 84
// module chunks = 0